import React, { Component } from "react";
import { Select, Spin } from "antd";
import axios from "axios";
import moment from "moment";

const { Option } = Select;

// Selector de un zip ya descargado en Descargas SAT (modo "guardar zip"), filtrado
// por empresa y emisión/recepción. Se usa como alternativa a subir un zip de nuevo,
// tanto en la pantalla de importar desde SAT como en CXCImplementacion/CXPImplementacion.
class SeleccionarZipDescargaSat extends Component {
  state = {
    opciones: [],
    cargando: false,
  };

  componentDidMount() {
    this.consultar();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.empresaId !== this.props.empresaId ||
      prevProps.emision !== this.props.emision
    ) {
      this.consultar();
    }
  }

  consultar() {
    const { empresaId, emision, headersToken } = this.props;
    if (!empresaId) {
      this.setState({ opciones: [] });
      return;
    }
    this.setState({ cargando: true });
    axios
      .post(
        "descargasSatBiwo/listarZipsDisponibles",
        { empresaId, emision },
        { headers: headersToken }
      )
      .then((res) => {
        this.setState({
          cargando: false,
          opciones: res.data.success === 2 ? res.data.zips : [],
        });
      })
      .catch(() => this.setState({ cargando: false, opciones: [] }));
  }

  render() {
    const { value, onChange, placeholder } = this.props;
    return (
      <Spin spinning={this.state.cargando}>
        <Select
          allowClear
          placeholder={placeholder || "Elige un zip ya descargado"}
          style={{ width: "100%" }}
          value={value}
          onChange={onChange}
          notFoundContent={
            this.state.cargando ? undefined : "No hay zips descargados para esta empresa"
          }
        >
          {this.state.opciones.map((zip) => (
            <Option
              key={`${zip.solicitudId}-${zip.index}`}
              value={JSON.stringify({ solicitudId: zip.solicitudId, index: zip.index })}
            >
              {moment(zip.startDate).format("DD/MM/YYYY") + " - " + moment(zip.endDate).format("DD/MM/YYYY")} ({zip.fileName})
            </Option>
          ))}
        </Select>
      </Spin>
    );
  }
}

export default SeleccionarZipDescargaSat;
